// extracted by mini-css-extract-plugin
export var primitiveLabel = "_tr-0";